<app-card>
    <ng-template #header>
        <!-- Add New Note Button -->
        <div class="flex align-items-center justify-content-between">
            <div class="textSubheader large font-bold">{{ 'user.editUser.labels.customerNotes' | translate }}</div>
            @if (canEdit()) {
                <app-button
                    icon="pi-plus"
                    (clickEvent)="startEdit()"
                ></app-button>
            }
        </div>
    </ng-template>

    <ng-template #content>
        <div class="input-grid-gaps grid-6col gap-y-6">
            <!-- Note Text or Edit Mode -->
            <div class="fr-5">
                <!-- Display Note Text -->
                @if (selectedNote) {
                    <p class="note-text" [innerHtml]="selectedNote.note"></p>
                }

                @if (canEdit()) {
                    @if (selectedNote && true) {
                        <app-link-button
                            [label]="'user.editUser.links.edit' | translate"
                            (click)="startEdit(selectedNote)">
                        </app-link-button>
                    }
                }

                <!-- Display Placeholder -->
                @if (!selectedNote) {
                    <p class="italic text-gray"> {{ 'user.editUser.placeholders.selectNote' | translate }} </p>
                }
            </div>

            <!-- List of Notes -->
            <div class="flex flex-column gap-small">
                @for (note of store.notes(); track $index) {
                    <div
                        class="note-item"
                        (click)="selectNote(note)"
                        [class.selected]="note === selectedNote"
                    >
                        {{ note.date | shortDate }}
                    </div>
                }
            </div>
        </div>
    </ng-template>
</app-card>
